import { takeUntil } from 'rxjs/operators';
import { Component } from '@angular/core'
import { select, Store } from '@ngrx/store'

import { Observable } from 'rxjs'

import * as auth from './../../actions/auth.actions'
import * as fromAuth from './../../reducers'

import { Authenticate } from '../../models/auth'

import { ContainerBase } from '../../../core/base/container-base'
import * as status from '../../../base/actions/status.actions'

@Component({
  selector: 'app-login-container',
  templateUrl: './template.html'
})
export class LoginContainer extends ContainerBase {
  error$: Observable<any>
  loggingIn$: Observable<boolean>

  constructor(
    private store: Store<fromAuth.State>
  ) {
    super()

    this.error$ = store.pipe(select(fromAuth.getLoginPageError), takeUntil(this.destroyed$))
    this.loggingIn$ = store.pipe(select(fromAuth.isLoginWorking), takeUntil(this.destroyed$))

    // remove header space
    //this.store.dispatch(new status.SetHeader(false));

  }

  login(event: Authenticate){
    this.store.dispatch(new auth.Login(event))
  }
}
